import { Component, HostBinding } from '@angular/core';
import { DatePipe } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [DatePipe]
})

export class FooterComponent{
    // Variables
    currentDate : Date = new Date();
    companyName = environment.branding.companyName;
}
